import React from 'react';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

interface IProps {
  caption?: string;
  backgroundImg?: string;
  children: React.ReactNode;
}

const PREFIX = 'ImageSlide';

const classes = {
  imageContainer: `${PREFIX}-imageContainer`,
  caption: `${PREFIX}-caption`,
  gradient: `${PREFIX}-gradient`,
};

const Root = styled('div')<{ backgroundImg?: string }>(({ theme, backgroundImg }) => ({
  [`&.${classes.imageContainer}`]: {
    position: 'relative',
    pointerEvents: 'none',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',

    '&::before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      display: 'block',
      backgroundImage: backgroundImg ? `url(${backgroundImg})` : undefined,
      backgroundSize: '100% 100%',
      opacity: 0.9,
      filter: 'blur(8px)',
    },
  },

  [`& .${classes.caption}`]: {
    color: 'white',
    padding: theme.spacing(2),
  },

  [`& .${classes.gradient}`]: {
    width: '100%',
    height: 110,
    background:
      'linear-gradient(to top, rgba(0,0,0,0) 0%, rgba(0,0,0,.01) 10%, rgba(0,0,0,.02) 20%, rgba(0,0,0,.35) 100%)',
    position: 'absolute',
    top: 0,
    zIndex: 2,
  },
}));

export const ImageSlide = ({ caption, children, backgroundImg }: IProps) => {
  return (
    <Root
      backgroundImg={backgroundImg}
      className={classes.imageContainer}>
      {caption && (
        <div className={classes.gradient}>
          <Typography variant="body2" className={classes.caption}>
            {caption}
          </Typography>
        </div>
      )}
      {children}
    </Root>
  );
};
